import React,{useState,useContext,useEffect} from "react";
import { Button, InputAdornment, TextField, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Box} from "@mui/material";
import { useTranslation } from 'react-i18next';
import { useSelector,useDispatch } from "react-redux";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import DelimiterDialog from "../TemplateProperties/DelimiterDialog";
import { treeActions } from "../../redux/slices/treeSlice";
import { newTemplateActions } from "../../redux/slices/newTemplateSlice";
import LightTooltip from "../../commonComponents/LightTooltip";
function ItemPropertiesDelimiterInput(props) {
    const { t } = useTranslation();
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector(state => state.treeData[parentScreen]);
    const quickAdd = useSelector(state => state.treeData[parentScreen].quickAdd);
    const dataValidationDelim = useSelector(state => state.treeData[parentScreen].dataValidationDelim)
    const {selectedNode} = rightTree.tree[rightTree.currentTab];
    const {DelimitedHeaderData} = useSelector(state => state.newTemplate)
    const [value,setValue] = useState('')
    const [editTooltipOpen, setEditTooltipOpen] = useState(false);
    const [delimInput, setDelimInput] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const dispatch = useDispatch();
    const handleChange = (key, value) => {
        dispatch(treeActions.setRightTreeSelectedNode({screen: parentScreen, type:rightTree.currentTab, data:{...selectedNode,[key]:value}}));
       if(DelimitedHeaderData){
         dispatch(newTemplateActions.setDelimitedHeaderData({...DelimitedHeaderData,[key]:value}))
       }
      }
    const delimDisplay = (val, modal) => {
    
        // Display values in certain ways depending on a few specific conditions:
        // - If no delim val -> 'No Delimiter Chosen'.
        // - Replace 'CR' and 'LF' (ascii 13 and 10) OR '%0D' '%0A' -> display 'CR', 'LF', 'CRLF' in latin characters.
        // - If val is one or two char length -> display 'ASCII 42 (*)' delimited by comma.
        // - else -> display the decoded string (even if it's just empty chars ?)
        if(val === undefined) return '';
        if (!modal) {
          if (typeof val === 'boolean'|| val === t('TXT_NO_DELIM_CHOSEN') || !val) return t('TXT_NO_DELIM_CHOSEN');
        }
        if (val === "CR" || val === "%0D" || val === "\r") return "CR";
        if (val === "LF" || val === "%0A" | val === "\n" ) return "LF";
        if (val === "CRLF" || val === "%0D%0A") return "CRLF";
    
        try { val = decodeURIComponent(val) } 
        catch (e) { 
          //case - malformed URI
          //console.log(`delimDisplay - URI malformed, can not decode - ${props.label} '${val}' - Displaying raw.`) 
        }
    
        return val.length < 3 ?
          val.split('').map(e => `ASCII ${e.charCodeAt(0)} (${e})`).join(', ')
          : val;
      }
  const handleEditAction = (action) => {
    switch (action) {
      case 'click':
        if(DelimitedHeaderData){
          setDelimInput(delimDisplay(DelimitedHeaderData[props.name], true));
        }

       else{
         setDelimInput(delimDisplay(selectedNode[props.name], true))
       }
        
        setModalOpen(true);
        setEditTooltipOpen(false);
        break;
      case 'enter':
        setEditTooltipOpen(true)
        break;
      case 'leave':
        setEditTooltipOpen(false);
        break;
    }
  }
  const handleDelimitedInput = (val) => {
    if (val) {
      const newDelimVal = delimDisplay(val, true)
      setValue(delimDisplay(newDelimVal, true))
    } else setValue(val, true)
  }
  const handleModalAction = (save) => {
    if (save) handleChange(props.name, delimInput);
    setModalOpen(false);
  }

  useEffect(() => {
    if(props?.source !== "NTW"){
      let delimiter = delimDisplay(selectedNode?.[props.name], true);
      if(props?.source === "QUICK_ADD"){
        delimiter = delimDisplay(quickAdd?.[props.name],true)
      } 
      if(props?.source === 'DATA_VALIDATION'){
        delimiter = delimDisplay(dataValidationDelim?.[props.name], true)
      }
      setValue(delimiter);
    } else if (DelimitedHeaderData && props?.source === "NTW"){
      const delimiter = delimDisplay(DelimitedHeaderData?.[props.name],true)
      setValue(delimiter)
    } 
  },[rightTree.currentTab?.selectedNode?.[props.name],selectedNode?.key,DelimitedHeaderData,quickAdd,dataValidationDelim]);
  return (
    <>
      <TextField
        size="small"
        variant="outlined"
        className="width-100 delim-button"
        label={props.label}
        value={value || t("TXT_NO_DELIM_CHOSEN")}
        onClick={() => handleEditAction('click')}
        onMouseEnter={() => handleEditAction('enter')}
          onMouseLeave={() => handleEditAction('leave')}
          InputProps={{
            readOnly: true,
            endAdornment: (
            <InputAdornment position="end">
              <LightTooltip
                className="margin-left-4" 
                title={t('CASCHE_EDIT')}
                placement={"right-start"}
                open={editTooltipOpen}
              >
                <Button 
                  size="small"
                  sx={{
                    width: '100% !important', 
                    minWidth: '100% !important',
                  }}
                  onClick={() => handleEditAction('click')}
                  onMouseEnter={() => handleEditAction('enter')}
                  onMouseLeave={() => handleEditAction('leave')}
                >
                  <BorderColorIcon fontSize='medium'/>
                </Button>
              </LightTooltip>
            </InputAdornment>)
          }}
        >

        </TextField>
        
        {modalOpen && <DelimiterDialog 
          modalOpen={modalOpen} 
          close={() => handleModalAction()} 
          from={'itemProp'}
          handleInput={handleDelimitedInput}
          val={value}
          name={props.name}>
        </DelimiterDialog>}
    </>
  );
}

export default ItemPropertiesDelimiterInput;
